import Box from "@/elements/Box";
import Typography from "@/elements/Typography";
import { useTranslation } from "react-i18next";

interface ProgressBarProps {
  activeStep: number;
  displayStep: number;
  currentTotalSteps: number;
  progress: number;
}

export function ProgressBar({ activeStep, displayStep, currentTotalSteps, progress }: ProgressBarProps) {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: "100vw",
        marginLeft: "calc(-50vw + 50%)",
        mb: 4,
        px: { xs: 2, md: 0 },
      }}
    >
      <Box 
        display="flex" 
        justifyContent="space-between" 
        mb={1} 
        sx={{ 
          maxWidth: "md", 
          mx: "auto", 
          px: { xs: 2, md: 0 }, 
          opacity: activeStep > 0 ? 1 : 0, 
          transition: "opacity 0.4s ease" 
        }}
      >
        <Typography variant="body2" sx={{ color: "#666" }}>
          {t("richiestaPreventivo.step", { current: displayStep, total: currentTotalSteps })}
        </Typography>
        <Typography variant="body2" sx={{ color: "#d4a017", fontWeight: "bold" }}>
          {Math.round(progress)}%
        </Typography>
      </Box>
      <Box sx={{ maxWidth: "md", mx: "auto", px: { xs: 2, md: 0 } }}>
        <style>{`
          #richiesta-progress {
            width: 100%;
            height: 8px;
            border-radius: 4px;
            border: none;
            accent-color: #d4a017;
          }
          #richiesta-progress::-webkit-progress-bar {
            background-color: #e0e0e0;
            border-radius: 4px;
          }
          #richiesta-progress::-webkit-progress-value {
            background-color: #d4a017;
            border-radius: 4px;
          }
          #richiesta-progress::-moz-progress-bar {
            background-color: #d4a017;
            border-radius: 4px;
          }
        `}</style>
        <progress
          id="richiesta-progress"
          value={progress}
          max={100}
        />
      </Box>
    </Box>
  );
}
